export function LoginCheckerModal({ method, message })
{
    return (

        <div className="modal-container">
            <div className="container">
                <div className="row vh-100 d-flex align-items-center justify-content-center px-2">
                    <div className="col-md-6 bg-white p-4 d-flex flex-column rounded-3">
                        <button className="btn-close btn-close-white position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={ ()=>{ method ( false ) } } ></button>
                        <div className="d-flex border-top border-bottom p-5 bg-green-light mb-2">
                            <p className="text-muted lead"> { message } </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export function LoginCheckerModalFromSubApp({ method, message })
{
    return (

        <div className="modal-container">
            <div className="container">
                <div className="row vh-100 d-flex align-items-center justify-content-center px-2">
                    <div className="col-md-6 bg-white p-4 d-flex flex-column rounded-3">
                        <button className="btn-close btn-close-white position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={ method } ></button>
                        <div className="d-flex flex-column border-bottom p-4 mb-2">
                            <p className="alert alert-success rounded mb-3"> { message } </p>
                            <p className="text-muted lead ps-4"> L'application Agriteam  </p>
                            <p className="text-muted lead ps-4"> L'application Farmspace  </p>
                            <p className="text-muted lead ps-4"> L'application Jaribot  </p>    
                        </div>
                        <p className="text-secondary px-4"> Veuillez fermer cette fenêtre et vous authentifier au préalable avant d’accéder aux autres applications. </p>    
                    </div>
                </div>
            </div>
        </div>
    )
}